import ops from '@/assets/js/vuescrollOption';
import User from "@/assets/images/person.png";
import {getScoreInfo, uploadScore} from "@/api/training_teacher/api";
import {operationMsgSave} from "@/api/common/api";
import {storageData} from "@/assets/js/storage";
let {values} = Object;
const role_type=storageData.getUserType();
export default {
  data() {
    /*const uploadErr = {
      tips: "成绩填写不完整，请填写完整！",
      num: 0
    };*/
    const backWarn = {
      flag: false,
      tips: "确定放弃修改并返回吗？"
    };
    const uploadWarn = {
      flag: false,
      tips: role_type === 'teacher' ? "确定暂时保存吗？" : "确定保存吗？"
    };
    const nextWarn = {
      flag: false,
      tips: "确定保存，并进入下一步吗?"
    };
    const submitUploadEducationWarn = {
      flag: false,
      tips: "确定提交成绩吗?"
    };
    return {
      c_id: this.$route.query.c_id,
      role_type:role_type,
      ops: ops(),
      examObj:{},
      commonStuList:[],
      fail:0,
      User,
      classInfo: {},
      showList: false,
      student_status:true,
      formVal: [],
      // uploadErr,
      backWarn,
      uploadWarn,
      submitUploadEducationWarn,
      nextWarn,
      note: "如有备注，可在此输入。",
      repeatSubmit: false,
      showTotal: false,
      passNum: 0,
      disScrollOpt: ops(true),
      showPreScore: false,
      ifDiaShow: false,
      stuUid: "",
      loading: false,
    };
  },
  filters: {
    getGender(gender) {
      return gender === "Male" ? "男" : "女";
    },
    showScore(status) {
      switch (status) {
        case "pass": status = "通过"; break;
        case "fail": status = "未通过"; break;
        case "practice_make_up": status = "实践课补考"; break;
        default: status = ""; break;
      }
      return status;
    },
    preScore(val) {
      let result = "--";
      val !== "" && (result = val);
      return result;
    },
    tipMsg(student_information,is_restrict_stu_info){
      let msg ="";
      if(student_information === 'verify' && is_restrict_stu_info === 0){
        msg ="该学员没有激活学员帐户，无法录入成绩。";
      }
      return msg;
    }
  },
  components: {
    "score-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "score-input": () => import("@/components/score/components/score-input"),
    "stu-detail-info": () => import("@/components/StuDeatilInfo/student-info"),
  },
  created() {
    this.getStusList();
  },
  methods: {
    getStusList() {
      getScoreInfo({c_id: this.c_id})
        .then(({data})=>{
          if(Number(data.status) === 0) {
            const {class_info, student_data, score_data, achievement_detail_data, achievementSubject} = data.result;
            this.classInfo = class_info;
            let examList=[],a=0;
            let examObj={};
            if(score_data.length > 0){ // 编辑
              let scoreArr = [];
              this.formVal = score_data.map((item, index) => {
                if(item.enroll_type === 'make_up_exam'){
                  examList.push(index);
                  examObj[index] = ++a;
                }
                scoreArr = [];
                if(achievement_detail_data.length > 0){
                  achievement_detail_data.map((e) => {
                    var pushItem = {
                      ...e,
                      err:false
                    };
                    if(item.achievement_id === e.achievement_id){
                      if(item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0){
                        if(pushItem.achievement_subject_des !== "踢球能力*"){
                          pushItem.achievement_score = "0";
                        }else{
                          pushItem.achievement_score = "一般";
                        }
                      }
                      scoreArr.push(pushItem);
                    }
                  });
                }
                return {
                  uid:item.uid,
                  user_id:item.stu_id,
                  user_name:item.user_name,
                  id_number:item.id_number,
                  practice_avg_points:item.practice_avg_points,
                  gender:item.gender,
                  enroll_type:item.enroll_type,
                  mobile_phone:item.mobile_phone,
                  user_img:item.profile_picture,
                  remark:item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "该学员没有激活学员帐户，无法录入成绩。" : item.ability_remark,
                  results_status:item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "fail" : item.results_status,
                  total_points:item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "0" : item.total_points,
                  student_information:item.student_information,
                  scoreArr
                };
              });
            } else { // 上传
              this.formVal = student_data.map((item,index)=>{
                let arr=[];
                if (item.enroll_type==='common'){
                  achievementSubject.map((e)=>{
                    if (e.achievement_subject_id !== 37 && e.achievement_subject_id !==44){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? e.achievement_subject_title!=="踢球能力" ? "0" : "一般" : "",
                        err: false
                      })
                    }
                    return e
                  })
                }else if(item.enroll_type==='make_up_exam'){
                  examList.push(index)
                  examObj[index]=++a;
                  achievementSubject.map((e)=>{
                    if (e.achievement_subject_id === 37 || e.achievement_subject_id ==44){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? e.achievement_subject_title!=="踢球能力" ? "0" : "一般" : "",
                        err: false
                      })
                    }
                    return e
                  })
                }else{
                  achievementSubject.map((e)=>{
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? e.achievement_subject_title!=="踢球能力" ? "0" : "一般" : "",
                        err: false
                      })
                    return e
                  })
                  // const arr = achievementSubject.map((e) => {
                  //   return {
                  //     ...e,
                  //     achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                  //     achievement_score: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? e.achievement_subject_title!=="踢球能力" ? "0" : "一般" : "",
                  //     err: false
                  //   };
                  // });
                }
                return {
                  uid: item.uid,
                  user_id:item.user_id,
                  user_name: item.user_name,
                  id_number: item.id_number,
                  gender: item.gender,
                  practice_avg_points:'',
                  enroll_type:item.enroll_type,
                  mobile_phone: item.mobile_phone,
                  user_img: item.user_profile_picture,
                  student_information: item.student_information,
                  remark: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "该学员没有激活学员帐户，无法录入成绩。" : "",
                  results_status: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "fail" : "",
                  total_points: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "0":"",
                  scoreArr: JSON.parse(JSON.stringify(arr))
                };
              });
            }
            if (examList.length>0){
              this.$set(this.formVal[examList[0]],'border',true);
              this.$set(this.formVal[Number(examList[0])],'showTotal',true);
              this.examObj=examObj;
            }else{
              this.$set(this.formVal[this.formVal.length - 1 ],'showTotal',true);
            }
            this.getResult();
            this.showList = true;
          }
        })
        .catch((err)=>{
          console.error(err);
        });
    },
    getScore(idx) {
      switch (this.classInfo.class_level) {
        case "C":
          this.levelCScore(idx);
          break;
        case "D":
          this.levelDScore(idx);
          break;
        case "B":
          this.levelBScore(idx);
          break;
        case "A":
          this.levelBScore(idx);
          break;
      }
      this.getResult();
    },
    levelAScore(idx) {
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, sum, theory, rule;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考核1")) {
          exam1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核2")) {
          exam2 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("综合能力评价")) {
          sum = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("理论笔试")) {
          theory = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("规则考试")) {
          rule = Number(item.achievement_score);
        }
      });
      let tempArr = [exam1, exam2, sum].filter((i) => {
        return i >= 70;
      });
      if (tempArr.length >= 2 && theory >= 60 && rule >= 80) {
        this.$set(this.formVal[idx], "results_status", "pass");
      } else {
        this.$set(this.formVal[idx], "results_status", "fail");
      }
    },
    levelBScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, exam3, theory, theory1, oral,maek_up_exam;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考核1")) {
          exam1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核2")) {
          exam2 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核3")) {
          exam3 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("一般理论")) {
          theory = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("专项理论")) {
          theory1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("口试")) {
          oral = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      });
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      } else{
        if (exam1 || exam2 || exam3 || theory || theory1 || oral){
          let average= ((exam1 + exam2 + exam3 + theory + theory1 +oral ) / 6 ).toFixed(2);
          this.$set(this.formVal[idx], "practice_avg_points", average);
        }else{
          this.$set(this.formVal[idx], "practice_avg_points", '');
        }
        let tempArr = [exam1, exam2, exam3].filter((i) => {
          return i >= 70;
        });
        let tempArr1 = [exam1, exam2, exam3].filter((i) => {
          return i >= 42;
        });
        let tempArr2=[theory, theory1,oral].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length >= 2 && tempArr2.length === 3 &&  tempArr1.length === 3) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==3){
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr1.length >= 2 && tempArr.length>=1){
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
      }
      }
    },
    levelCScore(idx) {
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, sum, theory, rule;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考核1")) {
          exam1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核2")) {
          exam2 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("综合能力评价")) {
          sum = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("理论笔试")) {
          theory = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("规则考试")) {
          rule = Number(item.achievement_score);
        }
      });
      let tempArr = [exam1, exam2, sum].filter((i) => {
        return i >= 70;
      });
      if (tempArr.length >= 2 && theory >= 60 && rule >= 80) {
        this.$set(this.formVal[idx], "results_status", "pass");
      } else {
        this.$set(this.formVal[idx], "results_status", "fail");
      }
    },
    levelDScore(idx) {
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      let score = 0;
      let flagArr = [];
      arr.map((v) => {
        if (!v.achievement_subject_des.includes("实践能力")) {
          flagArr.push(v.achievement_score);
        }
        score += v.achievement_score * v.achievement_subject_weight;
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (score === 0) {
        this.$set(item, "total_points", 0);
        this.$set(item, "results_status", "fail");
      } else {
        score = Math.round(score);
        this.$set(item, "total_points", score);
        flagArr.push(score);
        const flag = flagArr.every((el) => {
          return Number(el) >= 60;
        });
        flag
          ? this.$set(item, "results_status", "pass")
          : this.$set(item, "results_status", "fail");
      }
    },
    getResult() {
      if (this.classInfo.class_level==='C' || this.classInfo.class_level==='D' || this.classInfo.class_train_type === 'continue_education' ){
        let pass = 0, fail = 0;
        this.formVal.map((item) => {
          item.results_status === "pass" && (pass++);
          item.results_status === "fail" && (fail++);
        });
        this.passNum = pass;
        this.showTotal = Boolean(pass + fail === this.formVal.length);
      } else{
        let pass = 0, fail = 0,exam=0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type==='common'
        })
        this.commonStuList=stuList;
        this.commonStuList.map((item) => {
          (item.results_status === "pass" && item.enroll_type==='common')  && (pass++);
          (item.results_status === "fail" && item.enroll_type ==='common' ) && (fail++);
          (item.results_status === "practice_make_up" && item.enroll_type ==='common' ) && (exam++);
        });
        this.fail=fail;
        this.passNum = pass;
        this.showTotal = Boolean(pass + fail + exam === this.commonStuList.length);
      }

    },
    checkVal() {
      let err = false;
      this.formVal.map((item) => {
        item.scoreArr.map((v) => {
          if (v.achievement_score === "") {
            v.err = true;
            err = true;
          }
        });
      });
      return err;
    },
    checkValEducation() {
      let err = false;
      this.formVal.map((item) => {
        if (item.results_status === '') {
          item.err = true;
          err = true;
        }
      });
      return err;
    },
    async submitScore(flag, bool) {
      let operation_msg_id = '0';
      let save_status = '';
      this.loading = true;
      // 点保存了  都保存一下信息
      // 把头像字段给清空了 不然数据太长会出错
      this.formVal.map(item => {
        item.user_img = ''
        return item
      })
      if(flag === 'audit'){
        save_status = 'audit';
      }
      await operationMsgSave({
        c_id:this.c_id,
        student_score_data:JSON.stringify(this.formVal),
        operation_type:'save_score'
      }).then(({data}) => {
        operation_msg_id = data.result.operationMsg.msg_id;
      })
      uploadScore({c_id: this.c_id, student_score_data: JSON.stringify(this.formVal),operation_msg_id:operation_msg_id,save_status:save_status})
        .then(({data}) => {
          this.loading = false;
          if (Number(data.status) === 0) {
            if (flag === "back") {
              this.$set(this.backWarn, "flag", bool);
              this.$message.success("暂时保存成功");
              this.$router.go(-1);
            }
            if (flag === "next") {
              this.$set(this.nextWarn, "flag", bool);
              this.$message.success("成绩保存成功");
              this.$router.push({
                path: "class_report",
                query: {
                  c_id: this.c_id
                }
              });
            }
            if (flag === "audit") {
              this.$set(this.submitUploadEducationWarn, "flag", bool);
              this.$message.success("成绩提交成功");
              this.$router.go(-1);
            }
          } else {
            throw new Error(data.msg || "提交失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    userImgError(idx) {
      this.$set(this.formVal[idx], "user_img", this.User);
    },
    goBack() {
      this.$set(this.backWarn, "flag", true);
    },
    hideBackTips(bool, flag) {
      this.$set(this.backWarn, "flag", bool);
      if(flag) {
        this.$router.go(-1);
      }
    },
    nextStep() {
      const err = this.checkVal();
      if(!err) {
        this.$set(this.nextWarn, "flag", true);
        return false;
      }
      this.$message({
        type: "error",
        message: "请完善成绩信息"
      });
    },
    hideNextTips(bool, flag) {
      if (this.repeatSubmit) return;
      if (flag) {
        this.repeatSubmit = true;
        this.submitScore("next", bool);
      } else {
        this.$set(this.nextWarn, "flag", bool);
      }
    },
    tempUpload() {
      this.$set(this.uploadWarn, "flag", true);
    },
  
    submitUploadEducation(){
      const err = this.checkValEducation();
      if(!err) {
        this.$set(this.submitUploadEducationWarn, "flag", true);
        return false;
      }
      this.$message({
        type: "error",
        message: "请完善成绩信息"
      });
    },
    
    // 继续教育的提交
    hideSubmitUploadEducationTips(bool, flag) {
      
      if (this.repeatSubmit) return;
      if (flag) {
        this.repeatSubmit = true;
        this.submitScore("audit", bool);
      } else {
        this.$set(this.submitUploadEducationWarn, "flag", bool);
      }
      
    },
    hideUploadTips(bool, flag) {
      if(this.repeatSubmit) return;
      if(flag) {
        this.repeatSubmit = true;
        this.submitScore("back", bool);
      } else {
        this.$set(this.uploadWarn, "flag", bool);
      }
    },
    previewScore() {
      this.showPreScore = true;
    },
    viewDetail(uid) {
      this.stuUid = uid;
      this.ifDiaShow = true;
    },
  }
}
